/**
 * Configuração centralizada da API baseada no ambiente
 */

// Configuração da API com detecção automática de ambiente (local vs produção)
function getApiBaseUrl() {
  // CORREÇÃO CRÍTICA: Detectar produção baseado APENAS no protocolo e hostname
  const isHTTPS = window.location.protocol === 'https:';
  const isProdDomain = window.location.hostname === 'sophya.dhtech.com.br';
  const isLocalhost = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';

//   console.log('[API-CONFIG] Detecção de ambiente CORRIGIDA:', {
//     protocol: window.location.protocol,
//     hostname: window.location.hostname,
//     port: window.location.port,
//     isHTTPS,
//     isProdDomain,
//     isLocalhost,
//     // IGNORAR NODE_ENV para detecção de produção em web
//     nodeEnvIgnorado: process.env.NODE_ENV
//   });

  // PRIORIDADE 1: Verificar variáveis de ambiente específicas
  const envApiUrl = process.env.REACT_APP_API_URL || (window as any).ENV_API_URL;
  if (envApiUrl) {
//     console.log('[API-CONFIG] Usando URL da API de variável de ambiente:', envApiUrl);
//     console.log('[API-CONFIG] Variável REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
//     console.log('[API-CONFIG] Docker flag:', process.env.REACT_APP_DOCKER);
    return envApiUrl;
  }

  // PRIORIDADE 2: HTTPS + domínio de produção = SEMPRE usar HTTPS
  if (isHTTPS && isProdDomain) {
//     console.log('[API-CONFIG] PRODUÇÃO HTTPS detectada - usando HTTPS sem porta');
    return '/api';
  }

  // PRIORIDADE 3: Domínio de produção mas HTTP (redirecionamento)
  if (isProdDomain && !isHTTPS) {
//     console.log('[API-CONFIG] Domínio de produção em HTTP - forçando HTTPS');
    // Forçar redirecionamento para HTTPS
    window.location.href = `https://${window.location.hostname}${window.location.pathname}${window.location.search}`;
    return '/api';
  }

  // PRIORIDADE 4: Ambiente Docker
  const isDocker = process.env.REACT_APP_DOCKER === 'true' || 
                   document.cookie.includes('docker=true') ||
                   localStorage.getItem('docker_env') === 'true';
                   
  if (isDocker) {
//     console.log('[API-CONFIG] Ambiente Docker detectado');
    return 'http://backend:3001/api';
  }

  // PRIORIDADE 5: Localhost na porta 8082 = docker-compose.dev.yml (nginx proxia /api)
  // Neste caso NÃO deve conectar em localhost:3001 direto (bloqueado pelo CSP do nginx)
  const devDockerPort = window.location.port === '8082';
  if (isLocalhost && devDockerPort) {
//     console.log('[API-CONFIG] Docker dev (porta 8082) - usando /api relativo');
    return '/api';
  }

  // PRIORIDADE 6: Localhost puro (npm run dev / Vite direto) - usar porta 3001
  if (isLocalhost) {
//     console.log('[API-CONFIG] Desenvolvimento local puro - porta 3001 direta');
    return 'http://localhost:3001/api';
  }

  // PRIORIDADE 7: Fallback seguro
//   console.log('[API-CONFIG] Usando fallback baseado no protocolo atual');
  return `${window.location.protocol}//${window.location.hostname}/api`;
}

// Log da configuração final para debug
const finalConfig = getApiBaseUrl();
// console.log('[API-CONFIG] ===== CONFIGURAÇÃO FINAL =====');
// console.log('[API-CONFIG] BASE_URL escolhida:', finalConfig);
// console.log('[API-CONFIG] Window location completa:', window.location.href);
// console.log('[API-CONFIG] =====================================');

export const API_CONFIG = {
  BASE_URL: finalConfig,
  TIMEOUT: 60000, // 60s para suportar requisições de IA (Gemini pode demorar 30-40s)
  // CORREÇÃO: Configurações específicas para HTTPS
  HTTPS_CONFIG: {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }
};

// Validação adicional para prevenir mixed content
const baseUrl = API_CONFIG.BASE_URL;
const currentProtocol = window.location.protocol;

if (currentProtocol === 'https:' && baseUrl.startsWith('http:')) {
  console.error('[API-CONFIG] ERRO MIXED CONTENT DETECTADO!');
  console.error('Página HTTPS tentando acessar API HTTP:', baseUrl);
  
  // CORREÇÃO AUTOMÁTICA
  API_CONFIG.BASE_URL = baseUrl.replace('http:', 'https:');
//   console.log('[API-CONFIG] URL corrigida automaticamente:', API_CONFIG.BASE_URL);
}

// Salvar na sessão para uso em outros componentes
sessionStorage.setItem('api_base_url', API_CONFIG.BASE_URL);

// Debug detalhado
// console.log('[API-CONFIG] Configuração final da API:', {
//   baseUrl: API_CONFIG.BASE_URL,
//   timeout: API_CONFIG.TIMEOUT,
//   mixedContentCheck: {
//     pageProtocol: window.location.protocol,
//     apiProtocol: API_CONFIG.BASE_URL.split(':')[0] + ':',
//     compatible: window.location.protocol === (API_CONFIG.BASE_URL.split(':')[0] + ':')
//   },
//   location: {
//     hostname: window.location.hostname,
//     port: window.location.port,
//     protocol: window.location.protocol,
//     href: window.location.href
//   }
// });

export default API_CONFIG;
